import React, { useEffect, useState } from 'react';
import { Row, Col } from 'antd';
import { Link, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';

import Selectors from '../selectors';
import Actions from '../action';
import { AffiliateManagementPresentational } from './affiliate-management-presentational';

const AffiliateManagementFunctional = ({ getAffiliate, affiliateManagementLoading, affiliateManagementData }) => {
	const [filterType, setfilterType] = useState(null);
	const history = useHistory();
	const columns = [
		{
			title: 'Affiliate Name',
			dataIndex: 'sourceTitle',
			key: 'sourceTitle',
			width: '50%',
			render: (value, row, index) => {
				const firstLetter = value[0].toUpperCase();
				return (
					<Row align="middle">
						<Col
							className="flc"
							onClick={() => history.push(`/affiliate-management/view-affiliate/${row.sourceId}/${row.clientSourceId}`)}>
							<Col>
								<Col className={`${firstLetter}_text text_box flc`}>
									<Link
										style={{
											color: '#fff',
										}}>
										{firstLetter}
									</Link>
								</Col>
							</Col>
							<Col
								style={{
									cursor: 'pointer',
								}}>
								{value}
							</Col>
						</Col>
					</Row>
				);
			},
			sorter: (a, b) => a.sourceTitle.localeCompare(b.sourceTitle),
		},
		// {
		// 	title: 'Affiliate',
		// 	dataIndex: 'sourceTitle',
		// 	key: 'Affiliate',
		// 	width: '25%',
		// 	sorter: (a, b) => a.sourceTitle.localeCompare(b.sourceTitle),
		// },
		{
			title: 'Affiliate Id',
			dataIndex: 'clientSourceId',
			key: 'Affiliateid',
			width: '25%',
			sorter: (a, b) => a.clientSourceId.localeCompare(b.clientSourceId),
		},
		{
			title: 'Status',
			dataIndex: 'status',
			key: 'status',
			width: '25%',
			render: (value, row, index) => {
				return (
					<Row align="middle">
						<Col className="flc">
							<Col className={`${row.status.toUpperCase()} status_circle`} />
						</Col>
						<Col>{row.statusDesc}</Col>
					</Row>
				);
			},
		},
	];
	useEffect(() => {
		getAffiliate('All', history);
	}, []);

	const handleFilterChange = (value) => getAffiliate(value);

	return (
		<AffiliateManagementPresentational
			columns={columns}
			affiliateManagementData={affiliateManagementData}
			affiliateManagementLoading={affiliateManagementLoading}
			handleFilterChange={handleFilterChange}
		/>
	);
};

const mapStateToProps = (state) => {
	return {
		affiliateManagementLoading: Selectors.affiliateManagementLoading(state),
		affiliateManagementData: Selectors.affiliateManagementData(state),
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getAffiliate: (value, history) => dispatch(Actions.creators.getAffiliate(value, history)),
	};
};

const Connected = connect(mapStateToProps, mapDispatchToProps)(AffiliateManagementFunctional);

export default Connected;
